module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "item"
  }, [_c('router-link', {
    staticClass: "top",
    attrs: {
      "to": {
        name: 'Topic',
        params: {
          id: _vm.item.id
        }
      },
      "tag": "div"
    }
  }, [_c('div', {
    staticClass: "t_left"
  }, [_c('div', {
    staticClass: "tl_top"
  }, [_c('img', {
    attrs: {
      "src": _vm.item.author.avatar_url,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "author"
  }, [_c('span', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.item.author.loginname))]), _vm._v(" "), _c('span', {
    staticClass: "create"
  }, [_vm._v(_vm._s(_vm.item.create_at.substring(0, 10)))])])]), _vm._v(" "), _c('div', {
    staticClass: "tl_bottom",
    attrs: {
      "id": "title"
    }
  }, [_c('span', [_vm._v(_vm._s(_vm.item.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "t_right"
  }, [_c('span', {
    class: {
      good: _vm.item.good
    }
  }, [_vm._v("精华")]), _vm._v(" "), _c('span', {
    class: {
      top1: _vm.item.top
    }
  }, [_vm._v("置顶")])])]), _vm._v(" "), _c('div', {
    staticClass: "bottom"
  }, [_c('div', {
    staticClass: "b_item"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.visit_count))])]), _vm._v(" "), _c('div', {
    staticClass: "b_item"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.reply_count))])]), _vm._v(" "), _c('div', {
    staticClass: "b_item"
  }, [_c('i', {
    staticClass: "cnode-iconfont"
  }, [_vm._v("")]), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.item.last_reply_at.substring(5, 10)))])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dceaacf"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/list_item.vue
// module id = 143
// module chunks = 1